module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-8.0d8dde97.jpg";